/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Barra de tabs (POS, Catálogo…). No usa SafeAreaView: el inset superior lo aplica
 * MainTabsTabNavigator una sola vez para evitar doble reserva post-alta.
 * En web con sidebar el trigger de sucursal no se muestra (vive en el rail).
 */
import React from 'react';
import { useWindowDimensions } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { AppOperationalHeaderBar } from './AppOperationalHeader';
import { navigateRoot } from './rootNavigation';
import { isWebSidebarLayout } from './shellScreenOptions';

export { APP_TAB_HEADER_BAR_HEIGHT, getOperationalHeaderBarHeight } from './AppOperationalHeader';

type AppTabHeaderProps = {
  /**
   * Título de módulo. En MainTabs (chrome Square mobile A) se omite:
   * el nombre vive en el PaperSheet. ShellStack / stacks con back sí lo pasan.
   */
  title?: string;
  branchName?: string;
};

export function AppTabHeader({ title, branchName }: AppTabHeaderProps) {
  const navigation = useNavigation();
  const { width } = useWindowDimensions();
  const showBranchChip = Boolean(branchName) && !isWebSidebarLayout(width);

  return (
    <AppOperationalHeaderBar
      title={title}
      {...(showBranchChip
        ? {
            branchName,
            onPressBranch: () =>
              navigateRoot(navigation as NavigationProp<ParamListBase>, 'BranchSelector'),
          }
        : {})}
    />
  );
}
